import { api } from './api'
import {
  Immunisation,
  ImmunisationFormData,
  ImmunisationListResponse,
} from '../types/immunisation'

export interface CreatePatientImmunisationInput extends ImmunisationFormData {
  patientId: string
}

export interface UpdatePatientImmunisationInput extends Partial<ImmunisationFormData> {}

export const immunisationService = {
  /**
   * Get immunisations for a patient
   */
  getPatientImmunisations: async (
    patientId: string,
    params?: { dateFrom?: string; dateTo?: string },
  ): Promise<ImmunisationListResponse> => {
    const response = await api.get<ImmunisationListResponse>(
      `/patients/${patientId}/immunisations`,
      { params },
    )
    return response.data
  },

  /**
   * Create a new patient immunisation
   */
  createPatientImmunisation: async (
    patientId: string,
    payload: ImmunisationFormData,
  ): Promise<Immunisation> => {
    const response = await api.post<Immunisation>(
      `/patients/${patientId}/immunisations`,
      payload,
    )
    return response.data
  },

  /**
   * Update an existing patient immunisation
   */
  updatePatientImmunisation: async (
    patientId: string,
    immunisationId: string,
    payload: UpdatePatientImmunisationInput,
  ): Promise<Immunisation> => {
    const response = await api.put<Immunisation>(
      `/patients/${patientId}/immunisations/${immunisationId}`,
      payload,
    )
    return response.data
  },

  /**
   * Delete a patient immunisation
   */
  deletePatientImmunisation: async (
    patientId: string,
    immunisationId: string,
  ): Promise<void> => {
    await api.delete(`/patients/${patientId}/immunisations/${immunisationId}`)
  },
}
